import React, { useEffect, useState } from 'react';
import "./donation-widget.scss";
import { useFormContext } from 'react-hook-form';
import FieldError from '../../../shared/fields-errors/field-error';
import DonorCommentsTemplate from './donor-comments-template';
import { EMAIL_REGEX } from '../../../constants/pattern.constant';
import { getTextColorByBG, getHoverColor } from '../../../utils/utils';

function DonorUserInfo(props) {

    const { register, clearErrors } = useFormContext();
    const [isShowComments, setIsShowComments] = React.useState(false);
    const [ showComments, setShowComments ] = useState(false);

    const handleShowComments = () => {
        setIsShowComments(isShowComments);
    } 

    useEffect(() => {
        clearErrors();
    },[])
    return (
        <div className='col-12 campaign-focus-color' style={{ '--focus-color': props?.campaignDetail?.primary_color ? props?.campaignDetail?.primary_color : '#015B97' }}>
            <div className='row'>
                <div className='col-lg-6 mt-3'>
                    <div className="form-group"><label className="label-text form-control-label">
                    <span className='text-danger text-bold'>*</span> First Name</label>
                        <input onInput={(() => clearErrors('first_name'))} placeholder="First Name"
                            {...register("first_name", {
                                required: true
                            })}
                            type="text"
                            className="form-control-alternative form-control form-control-rounded" /></div>
                    {props?.errors?.first_name && props?.errors?.first_name?.type === 'required' ? <FieldError message={'First name is required'} /> : ''}
                </div>
                <div className='col-lg-6 mt-3'>
                    <div className="form-group"><label className="label-text form-control-label">
                    <span className='text-danger text-bold'>*</span> Last Name</label>
                        <input onInput={(() => clearErrors('last_name'))}
                            {...register("last_name", {
                                required: true
                            })}
                            placeholder="Last Name" type="text"
                            className="form-control-alternative form-control form-control-rounded" /></div>
                    {props?.errors?.last_name && props?.errors?.last_name?.type === 'required' ? <FieldError message={'Last name is required'} /> : ''}
                </div>
               
                <div className='col-lg-12 mt-3'>
                    <div className="form-group"><label className="label-text form-control-label">
                    <span className='text-danger text-bold'>*</span> Email</label>
                        <input onInput={(() => clearErrors('email'))}
                            {...register("email", {
                                required: true,
                                pattern: {
                                    value: EMAIL_REGEX,
                                    message: "Invalid email."
                                }
                            })} placeholder="Email" type="text"
                            className="form-control-alternative form-control form-control-rounded"  /></div>
                    {props?.errors?.email ? <FieldError message={
                        props?.errors?.email?.type === 'required' ?
                            'Email is required' :
                            props?.errors?.email?.type === 'pattern' ?
                                props?.errors?.email?.message : ''
                    } /> : ''}
                </div>

                {
                    (props?.campaignDetail?.collect_phone || props?.pledgeID) ?
                        <div className='col-lg-12 mt-3'>
                            <div className="form-group">
                            {
                                        (props?.fieldValidations?.phone || props?.pledgeID) ?
                                        <span className='text-danger'>*</span> : ""
                                    }
                                <label className="label-text form-control-label">Phone</label>
                                <input placeholder="Phone"
                                    {...register('phone', {
                                        validate:{
                                            required :(value) => {
                                                if(!value && (props?.fieldValidations?.phone || props?.pledgeID)){
                                                    return "The field is required"
                                                }
                                                return true
                                            }
                                        }
                                    })}
                                    type="text" className="form-control-alternative form-control form-control-rounded" />
                            </div>
                            {props?.errors?.phone ? <FieldError message={props?.errors?.phone?.message} /> : ''}
                        </div> : ''
                }
                

                {
                    props?.campaignDetail?.collect_address ?
                        <>
                         <div className='col-lg-12 mt-3'>
                                <div className="form-group"><label className="label-text form-control-label">
                                    {
                                        props?.fieldValidations?.address_required ?
                                        <span className='text-danger'>*</span> : ""
                                    }
                                    Address</label>
                                    <input placeholder="Address"
                                        {...register('address', {
                                            validate:{
                                                required :(value) => {
                                                    if(!value && props?.fieldValidations?.address_required){
                                                        return "The field is required"
                                                    }
                                                    return true
                                                }
                                            }
                                        })}
                                        type="text" className="form-control-alternative form-control form-control-rounded" />
                                </div>
                                {props?.errors?.address ? <FieldError message={props?.errors?.address?.message} /> : ''}
                            </div>
                            <div className='col-lg-6 mt-3'>
                                <div className="form-group"><label className="label-text form-control-label">
                                {
                                        props?.fieldValidations?.city_required ?
                                        <span className='text-danger'>*</span> : ""
                                }   City</label>
                                    <input placeholder="City"
                                        {...register('city', {
                                            validate:{
                                                required :(value) => {
                                                    if(!value && props?.fieldValidations?.city_required){
                                                        return "The field is required"
                                                    }
                                                    return true
                                                }
                                            }
                                        })}
                                        type="text" className="form-control-alternative form-control form-control-rounded" />
                                </div>
                                {props?.errors?.city ? <FieldError message={props?.errors?.city?.message} /> : ''}
                            </div>
                            <div className='col-lg-6 mt-3'>
                                <div className="form-group"><label className="label-text form-control-label">
                                {
                                        props?.fieldValidations?.state_province_required ?
                                        <span className='text-danger'>*</span> : ""
                                }
                                    State / Province</label>
                                    <input placeholder="State / Province"
                                        {...register('state_province',{
                                            validate:{
                                                required :(value) => {
                                                    if(!value && props?.fieldValidations?.state_province_required){
                                                        return "The field is required"
                                                    }
                                                    return true
                                                }
                                            }
                                        })}
                                        type="text" className="form-control-alternative form-control form-control-rounded" />
                                </div>
                            </div>
                            <div className='col-lg-6 mt-3'>
                                <div className="form-group"><label className=" label-text form-control-label">
                                {
                                        props?.fieldValidations?.postal_code_required ?
                                        <span className='text-danger'>*</span> : ""
                                }
                                    Postal Code</label>
                                    <input placeholder="Postal Code"
                                        {...register('postal_code',{
                                            validate:{
                                                required :(value) => {
                                                    if(!value && props?.fieldValidations?.postal_code_required){
                                                        return "The field is required"
                                                    }
                                                    return true
                                                }
                                            }
                                        })}
                                        type="text" className="form-control-alternative form-control form-control-rounded" />
                                </div>
                            </div>
                            <div className='col-lg-6 mt-3'>
                                <div className="form-group"><label className=" label-text form-control-label">
                                        <span className='text-danger'>*</span>Country</label>
                                    <input disabled placeholder="Country"
                                        {...register('country', {
                                            required: "Country is required",
                                            value:'USA'
                                        })}
                                        type="text" className="form-control-alternative form-control form-control-rounded" />
                                </div>
                                {props?.errors?.country ? <FieldError message={props?.errors?.country?.message} /> : ''}
                            </div>
                            
                           
                           
                            {/* <div className='col-lg-12 mt-4'>
                                <div className="form-group"><label className="form-control-label">Address 2</label>
                                    <input placeholder="Address 2"
                                        {...register('address_2')}
                                        type="text" className="form-control-alternative form-control" />
                                </div>
                            </div> */}
                        </> : ''
                }  
                </div>
                <hr className='donor-widget-hr' style={{
                marginTop: '20px',
                marginLeft: '-35px',
                // marginRight: '-35px',
                width: 'calc(100% + 72px)'
}} />
                 
                 <div className='row'>
                {
                    props?.campaignDetail.ask_donor_to_subscribe ? 
                     <div className='form-group '>
                    <label className="form-control-label d-flex align-items-center campaign-label-check" style={{ gap: '8px', cursor: 'pointer' }}>
                        <input
                            {...register("subscribe_to_mailing_list",{
                                value: props?.campaignDetail.ask_donor_to_subscribe_default ? true : false
                            })}
                            className="recurring-form-check" type="checkbox"
                            style={{'--checkbox-color': props?.campaignDetail?.primary_color || '#155C4E', marginTop: '-3px'}}
                        />
                        <p style={{
                            fontSize: '13px',
                            fontWeight: '600', color: '#555', margin: 0 }}> 
                        {props?.campaignDetail?.email_request_label}
                        </p>
                    </label>
                </div> : ''
                } 

                 {
                    props?.campaignDetail?.enable_anonymous ?
                    <div className="form-group mt-1">
                    <label className="form-control-label d-flex align-items-center campaign-label-check" style={{fontSize: '13px', fontWeight: '600', color: '#555', gap: '8px', cursor: 'pointer'}}>
                        <input {...register('make_anonymous_donation',{
                            value: false
                        })} className="recurring-form-check" type="checkbox"
                        style={{'--checkbox-color': props?.campaignDetail?.primary_color || '#155C4E', marginTop: '-3px'}}
                        />
                        Make donation anonymous
                    </label>
                </div> : ''
                }
                {/* {
    props?.campaignDetail?.donor_comments ?
        <>
            <div className='col-lg-12 mt-4'>
                <div className='d-flex align-items-center justify-content-start'>
                    <input checked={isShowComments}
                        onChange={handleShowComments} className="me-1" type="checkbox" />
                    <label className='f-14'>
                        Add Comments.
                    </label>
                </div>
            </div>

            {
                isShowComments ? 
                <div className='col-lg-12 mt-4'>
                <div className="form-group"><label className="form-control-label">Comments</label>
                    <textarea placeholder='Comments' cols="30" rows="3" className="form-control-alternative form-control"></textarea>

                </div>
            </div> : ''
            }
            
        </> : ''
} */}

                 {/* comment section */}

                
                 {
                    props?.campaignDetail?.is_donor_comments ? (
                    props?.campaignDetail?.is_comment_required ? (
                        <div className='col-lg-12 '
                        >
                            <DonorCommentsTemplate settings={props?.campaignDetail} descriptiveAmountView={true} />
                        </div>
                      ) : (
                    <div className='col-lg-12 mt-1'>
                        <span
                            onClick={() => setShowComments(!showComments)}
                            onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setShowComments(!showComments);
                            }
                           }}
                            tabIndex="0"
                            className='cursor-pointer comment-title'
                            style={{
                                textDecoration: 'underline',
                                '--dynamic-color': props?.campaignDetail?.primary_color ? props?.campaignDetail?.primary_color : '#015B97',
                            }}
                            >
                            {showComments ? 'Hide' : 'Add a'} comment
                        </span>
                        {
                            showComments ?
                            <DonorCommentsTemplate settings={props?.campaignDetail} descriptiveAmountView={true}/> : ''
                        }
                    </div>
            )
         ) : ''
        }
                <div className="col-lg-12 mt-4">
                    <div className="text-center position-relative">
                        {/* <button
        disabled={!options?.clientSecret}
            style={{
                backgroundColor: props?.campaignDetail?.primary_color ? (props?.campaignDetail?.primary_color) : '#005B97 !important'
            }}
            type="submit" className={`btn text-white btn-md w-100 `}>
            Next
        </button> */}
                        <button
                            onClick={props?.donorInfo}
                            //  disabled={!options?.clientSecret}
                            style={{
                                '--primary': props?.campaignDetail?.primary_color,
                                 '--primary-hover': getHoverColor(props?.campaignDetail?.primary_color),
                                 '--primary-text': getTextColorByBG(props?.campaignDetail?.primary_color),
                                   borderRadius: '8px',
                            }}
                            type="button" className={`btn btn-md w-100 text-white btn-step-one form-control-rounded`}>
                            <span >
                                <span className='f-18 mx-4'>Next</span>
                            </span>
                        </button>
                    </div>
                     {/* checkout content */}
                <div className="secure-row">
                         <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="7" width="10" height="7" rx="1.5"/><path d="M5 7V5a3 3 0 0 1 6 0v2"/></svg>
                           Secure checkout powered by Stripe
                        </div> 
                </div>  
            </div>
        </div>
    );
}

export default DonorUserInfo;